import React from 'react';
import ScrollHint from '../ScrollHint';

function TemplateTypeSelector({ 
  templateType,
  isOrgTeam,
  graphicsLimitInfo,
  orgTemplateSettings,
  onTemplateChange 
}) {
  return (
    <div className="template-selector">
      <label>Template Type</label>
      <div className="template-carousel-wrapper">
        <ScrollHint />
        <div className="template-buttons">
          <button
            type="button"
            className={`template-btn ${
              templateType === 'preview' ? 'active' : ''
            }`}
            onClick={() => onTemplateChange ('preview')}
          >
            Game Preview
          </button>
          <button
            type="button"
            className={`template-btn ${
              templateType === 'recap' ? 'active' : ''
            }`}
            onClick={() => onTemplateChange('recap')}
          >
            Game Recap
          </button>
          <button
            type="button"
            className={`template-btn ${
              templateType === 'highlight' ? 'active' : ''
            } ${
              (isOrgTeam &&
                orgTemplateSettings &&
                !orgTemplateSettings.allowPlayerHighlights)
                ? 'locked'
                : ''
            }`}
            onClick={() => {
              if (
                isOrgTeam &&
                orgTemplateSettings &&
                !orgTemplateSettings.allowPlayerHighlights
              ) {
                return;
              } else {
                onTemplateChange('highlight');
              }
            }}
          >
            ⭐ Player Spotlight
          </button>
          <button
            type="button"
            className={`template-btn ${
              templateType === 'tryout' ? 'active' : ''
            } ${
              (isOrgTeam &&
                orgTemplateSettings &&
                !orgTemplateSettings.allowTryouts)
                ? 'locked'
                : ''
            }`}
            onClick={() => {
              if (
                isOrgTeam &&
                orgTemplateSettings &&
                !orgTemplateSettings.allowTryouts
              ) {
                return;
              } else {
                onTemplateChange('tryout');
              }
            }}
          >
            Tryouts
          </button>
        </div>
      </div>
      {/* Upgrade messages */}
    </div>
  );
}

export default TemplateTypeSelector;